import React from "react";
import _ from "lodash";
import { Row, Col } from "react-flexbox-grid";
import Paper from "@material-ui/core/Paper";
import { useTagsWithValues } from "../data";
import { useTagValuesState } from "./state";
import TagItem from "./tag-item";
import { LinearProgress, Typography } from "@material-ui/core";

const TagValueSelector = ({ onChange, isChecked, filter }) => {
	if (filter.typing === "") {
		delete filter.typing;
	}
	const { loading, error, data } = useTagsWithValues(filter);
	const tags = _.get(data, "tags", []).map((tag) => (
		<Col xs={12} md={6} lg={4} key={tag.id}>
			<TagItem tag={tag} onChange={onChange} isChecked={isChecked} />
		</Col>
	));
	return (
		<Paper elevation={1}>
			{!loading && data && data.tags && data.tags.length === 0 ? (
				<Typography
					style={{
						fontFamily: "'Poppins', sans-serif",
						fontSize: 24,
						padding: 24
					}}
					align="center"
				>
					¡Área geográfica sin datos registrados!
				</Typography>
			) : loading ? (
				<LinearProgress variant="query" color="primary" />
			) : (
				<Row center="xs">{tags}</Row>
			)}
		</Paper>
	);
};

export default function useTagValueSelector(onChangeCb, filter) {
	const { onChange, isChecked, state, cleanState } = useTagValuesState(
		onChangeCb
	);
	return {
		Component: () => (
			<TagValueSelector
				onChange={onChange}
				isChecked={isChecked}
				filter={filter}
			/>
		),
		state,
		clean: cleanState
	};
}



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-values-selector/index.js